module.exports = __webpack_public_path__ + "img/benefit-card-bulk.1f2b6adc.svg";